// src/locales/en/quotation.js
export const quotation = {
  // Page titles
  quotations: 'Quotations',
  allQuotations: 'All Quotations',
  createQuotation: 'Create Quotation',
  editQuotation: 'Edit Quotation',
  quotationDetails: 'Quotation Details',
  viewAndManageAllQuotations: 'View and manage all quotations',
  createQuotationDescription: 'Create a quotation for a customer or prospect',

  // List columns
  quotationNumber: 'Quotation #',
  prospectName: 'Prospect Name',
  prospectPhone: 'Prospect Phone',
  customer: 'Customer',
  shop: 'Shop',
  allShops: 'All Shops',
  selectShop: 'Select Shop',
  customerName: 'Customer Name',
  customerPhone: 'Customer Phone',
  details: 'Quotation Details',
  createdBy: 'Created By',
  createdAt: 'Created At',
  validUntil: 'Valid Until',
  total: 'Total',
  status: 'Status',
  actions: 'Actions',

  // Status labels — used via t(`quotation.status_${quotation.status}`)
  status_draft:     'Draft',
  status_sent:      'Sent',
  status_accepted:  'Accepted',
  status_rejected:  'Rejected',
  status_expired:   'Expired',
  status_converted: 'Converted',

  // Form fields
  customerOrProspect: 'Customer / Prospect',
  existingCustomer: 'Existing Customer',
  newProspect: 'New Prospect',
  selectCustomer: 'Select Customer',
  prospectNamePlaceholder: 'Enter prospect name',
  prospectPhonePlaceholder: 'Enter prospect phone number',
  prospectEmail: 'Prospect Email',
  validUntilPlaceholder: 'Select expiry date',
  items: 'Items',
  addItem: 'Add Item',
  removeItem: 'Remove Item',
  product: 'Product',
  quantity: 'Quantity',
  unitPrice: 'Unit Price',
  discount: 'Discount',
  lineTotal: 'Line Total',
  lineDiscount: 'Line Discount',
  subtotal: 'Subtotal',
  tax: 'Tax',
  grandTotal: 'Grand Total',
  notes: 'Notes',
  notesPlaceholder: 'Add any notes for this quotation...',
  termsAndConditions: 'Terms & Conditions',

  // Actions
  create: 'Create Quotation',
  save: 'Save',
  send: 'Send',
  sendQuotation: 'Send Quotation',
  accept: 'Accept',
  acceptQuotation: 'Accept Quotation',
  reject: 'Reject',
  rejectQuotation: 'Reject Quotation',
  convert: 'Convert to Order',
  convertToOrder: 'Convert to Order',
  edit: 'Edit',
  duplicate: 'Duplicate',
  cancel: 'Cancel',
  print: 'Print',
  download: 'Download PDF',
  shareQuotation: 'Share Quotation',
  backToQuotations: 'Back to Quotations',
  print: 'Print',
  prospectCustomer: 'Prospect Customer',
  prospectName: 'Prospect Name',
  prospectPhone: 'Prospect Phone',
  noProductsFound: 'No products found',
  selectShopFirst: 'Select a shop before adding products',
  searchProductsPlaceholder: 'Search products or scan a barcode',
  createFirstQuotation: 'Create First Quotation',

  // Confirmations
  confirmSend: 'Are you sure you want to send this quotation to the customer?',
  confirmAccept: 'Mark this quotation as accepted?',
  confirmReject: 'Mark this quotation as rejected?',
  confirmConvert: 'Convert this quotation into an order? This action cannot be undone.',
  rejectionReason: 'Reason for Rejection',
  rejectionReasonPlaceholder: 'Enter reason for rejection...',

  // Filters
  filterByStatus: 'Filter by Status',
  filterByCustomer: 'Filter by Customer',
  dateFrom: 'From',
  dateTo: 'To',
  searchQuotations: 'Search by quotation #, prospect name, phone...',
  allStatuses: 'All Statuses',

  // Success / error messages
  quotationCreatedSuccessfully: 'Quotation created successfully',
  quotationUpdatedSuccessfully: 'Quotation updated successfully',
  quotationSentSuccessfully: 'Quotation sent successfully',
  quotationAcceptedSuccessfully: 'Quotation accepted successfully',
  quotationRejectedSuccessfully: 'Quotation rejected successfully',
  quotationConvertedSuccessfully: 'Quotation converted to order successfully',
  failedToCreateQuotation: 'Failed to create quotation',
  failedToUpdateQuotation: 'Failed to update quotation',
  failedToSendQuotation: 'Failed to send quotation',
  failedToLoadQuotations: 'Failed to load quotations',
  failedToLoadQuotationDetails: 'Failed to load quotation details',
  failedToLoadQuotation: 'Failed to load quotation',
  failedToLoadReferenceData: 'Failed to load reference data',
  failedToConvert: 'Failed to convert quotation',
  convertedSuccessfully: 'Quotation converted successfully',

  // Validation
  customerRequired: 'Please select a customer or enter prospect details',
  prospectNameRequired: 'Prospect name is required',
  prospectPhoneRequired: 'Prospect phone number is required',
  itemsRequired: 'Please add at least one item',
  validUntilRequired: 'Please select a valid-until date',
  validUntilMustBeFuture: 'Valid-until date must be in the future',
  atLeastOneItemRequired: 'Please add at least one item',
  someFieldsRequired: 'Please fix the highlighted fields before submitting',
  shopRequired: 'Please select a shop',

  // Empty states
  noQuotationsFound: 'No quotations found',
  noQuotationsYet: 'No quotations yet. Create your first quotation to get started.',
  noQuotationsMatchFilters: 'No quotations match your current filters',
  noQuotationsFoundDescription: 'No quotations match your current filters',
  noQuotationsYetDescription: 'Create your first quotation to get started.',

  // Conversion modal
  fulfillmentMethod: 'Fulfillment Method',
  fulfillmentCounterPickup: 'Counter Pickup',
  fulfillmentSelfDelivery: 'Self Delivery',
  fulfillmentCourier: 'Courier',
  orderStatus: 'Order Status',
  orderStatusCredit: 'Credit Sale',
  orderStatusCompleted: 'Completed Sale',
  immediateDelivery: 'Deliver immediately',
  confirmConvert: 'Convert this quotation into an order? This action cannot be undone.',

  // Detail page
  quotationInfo: 'Quotation Information',
  convertedToOrder: 'Converted to Order',
  viewOrder: 'View Order',
  expiresIn: 'Expires in {{days}} days',
  expired: 'Expired',
  na: 'N/A',
};
